<template>
    <div class="bax-banner-title-block">
        <div class="container">
            <div class="bax-banner-title d-flex align-items-center">
                <img src="~@/assets/images/login-img.png" alt="Welcome">
                <vue-heading :size="6">{{ hospitalName }}</vue-heading>
                <strong class="ml-auto" v-if="orderRefView !== ''">Order Ref: {{ orderRefView }}</strong>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OrderHeader',
    props: {
        orderId: {
            type: Number,
        },
        orderInfo: {
            default: null,
        },
    },
    data() {
        return {
            hospitalName: '',
            orderRefView: '',
        };
    },
    watch: {
        orderInfo(newVal) {
            /* eslint-disable */
            if (newVal !== null || newVal !== '') {
                this.orderRefView = newVal.orderRefView;
            } else {
                if (this.$route.params.orderId) {
                    this.orderRefView = this.$route.params.orderId;
                }
            }
        }
    },
    mounted() {
        this.hospitalName = this.$store.state.auth.user.hospitalName;
    },
};
</script>
